import {ReactComponent as Address} from "../assets/icons/address.svg";
import {ReactComponent as Arrow} from "../assets/icons/arrow-link.svg";
import {ReactComponent as Burger} from "../assets/icons/burger.svg";
import {ReactComponent as Chevron} from "../assets/icons/chevron-arrow.svg";
import {ReactComponent as Email} from "../assets/icons/email.svg";
import {ReactComponent as Instagram} from "../assets/icons/instagram-icon.svg";
import {ReactComponent as Location} from "../assets/icons/location.svg";
import {ReactComponent as PhoneCirlced} from "../assets/icons/phone-circled.svg";
import {ReactComponent as Phone} from "../assets/icons/phone.svg";
import {ReactComponent as PriceTag} from "../assets/icons/price-tag.svg";
import {ReactComponent as Quotes} from "../assets/icons/quotes.svg";
import {ReactComponent as Schedule} from "../assets/icons/schedule.svg";
import {ReactComponent as Scrolldown} from "../assets/icons/scrolldown.svg";
import {ReactComponent as TikTok} from "../assets/icons/tiktok-icon.svg";
import {ReactComponent as XIcon} from "../assets/icons/x-icon.svg";
import {ReactComponent as PriceTagBlob} from "../assets/icons/pricetag-blob.svg";
import {ReactComponent as LockBlob} from "../assets/icons/lock-blob.svg";
import {ReactComponent as CheckBlob} from "../assets/icons/check-blob.svg";
import {ReactComponent as BulbBlob} from "../assets/icons/bulb-blob.svg";
import {ReactComponent as ArrowHref} from "../assets/icons/href-arrow.svg";
import {ReactComponent as Achievement} from "../assets/icons/achievement.svg";
import {ReactComponent as Tooth} from "../assets/icons/tooth.svg";
import {ReactComponent as Star} from "../assets/icons/star.svg";
import {ReactComponent as User} from "../assets/icons/user.svg";
import {ReactComponent as Hygiene} from "../assets/icons/hygiene.svg";
import {ReactComponent as Equipment} from "../assets/icons/equipment.svg";
import {ReactComponent as Surgery} from "../assets/icons/surgery.svg";
import {ReactComponent as Pacifier} from "../assets/icons/pacifier.svg";
import {ReactComponent as Facebook} from "../assets/icons/facebook.svg";

export default function Icon({name, ...props}){
    switch (name){
        case "address":
            return <Address {...props} />
        case "arrow":
            return <Arrow {...props} />
        case "burger":
            return <Burger {...props} />
        case "chevron":
            return <Chevron {...props} />
        case "email":
            return <Email {...props} />
        case "instagram":
            return <Instagram {...props} />
        case "location":
            return <Location {...props} />
        case "phone-circled":
            return <PhoneCirlced {...props} />
        case "phone":
            return <Phone {...props} />
        case "pricetag":
            return <PriceTag {...props} />
        case "quotes":
            return <Quotes {...props} />
        case "schedule":
            return <Schedule {...props} />
        case "x-icon":
            return <XIcon {...props} />
        case "scrolldown":
            return <Scrolldown {...props} />
        case "pricetag-blob":
            return <PriceTagBlob {...props} />
        case "lock-blob":
            return <LockBlob {...props} />
        case "bulb-blob":
            return <BulbBlob {...props} />
        case "check-blob":
            return <CheckBlob {...props} />
        case "tiktok":
            return <TikTok {...props} />
        case "arrow-href":
            return <ArrowHref {...props} />
        case "achievement":
            return <Achievement {...props} />
        case "tooth":
            return <Tooth {...props} />
        case "star":
            return <Star {...props} />
        case "user":
            return <User {...props} />
        case "hygiene":
            return <Hygiene {...props} />
        case "facebook":
            return <Facebook {...props} />
        case "pacifier":
            return <Pacifier {...props} />
        case "surgery":
            return <Surgery {...props} />
        case "equipment":
            return <Equipment {...props} />
        default:
            return null;
    }
}